import React from 'react'

import bgContact from '../../assets/About/ContactBG.png'
import PrimeButton from '../../components/PrimeButton'




export default function ContactSection() {
  return (
    <section className={` bg-no-repeat bg-cover  py-20 text-white text-center px-4`} style={{backgroundImage:`url(${bgContact})`}}>
        <h3 className='font-bold text-4xl'>Partnering with H2A Medical Solutions Is the smart Choice
 </h3>
        <p className='my-5 font-light text-lg md:text-xl'>A trusted ally committed to improving patient outcomes and delivering tailored, high-quality medical solutions.</p>
        <PrimeButton  text='Contact us now' size='text-4xl'/>
        
    </section>
  )
}
